import styles from "./LicenseSingleKeyModal.module.scss";
import close from "../../../assets/icons/close.svg";
import { useTranslation } from "react-i18next";

import copy from "../../../assets/icons/copy.svg";
import copyHover from "../../../assets/icons/copy-hover.svg";
import done from "../../../assets/icons/status-done.svg";
import { useClipboard } from "../../../hooks/useClipboard";

interface LicenseKeysModalProps {
  setIsLicenseModalVisible: (arg: boolean) => void;
  keygen: string;
  name: string;
}

const LicenseSingleKeyModal: React.FC<LicenseKeysModalProps> = ({ setIsLicenseModalVisible, keygen, name }) => {
  const { t } = useTranslation();
  const { copied, copyToClipboard } = useClipboard(5000);

  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <p className={styles.root_header_title}>{name}</p>
        <div className={styles.root_header_imgBlock}>
          <img
            className={styles.root_header_img}
            src={close}
            alt="close"
            onClick={() => setIsLicenseModalVisible(false)}
          />
        </div>
      </div>

      <div>
        <p className={styles.root_subtitle}>
          <div className={styles.root_copyWrapper}>{keygen} </div>
        </p>

        <div className={styles.root_copyContainer} onClick={() => copyToClipboard(keygen)}>
          {!copied ? (
            <>
              <img
                onMouseOver={(e) => (e.currentTarget.src = copyHover)}
                onMouseOut={(e) => (e.currentTarget.src = copy)}
                src={copy}
                alt={`copy ${keygen}`}
                className={styles.copyIcon}
              />
              {t("Copy")}
            </>
          ) : (
            <>
              <img src={done} alt="done" />

              {t("Copied!")}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LicenseSingleKeyModal;
